
import { Box, Chip, Paper, Typography } from "@mui/material"
import {
  AccessTimeRounded,
  SentimentSatisfiedAltRounded,
  SentimentNeutralRounded,
  SentimentDissatisfiedRounded,
} from "@mui/icons-material"
import { palette, theme as colorTheme } from "../../../../Convoze.theme"



const ui = {
  // text: "#0f172a",
  text :colorTheme('palette', 'night').value,
  // subtext: "#6b7280",
  subtext:colorTheme('palette', 'secondary').value,
  border: "#e7e5ef",
  rowBg: "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(247,247,253,0.9) 100%)",
  tagBg: "#f3f4f6",
  tagBorder: "#e5e7eb",
}

function SentimentChip({ value }) {
  const map = {
    positive: {
      label: "positive",
      // color: "#16a34a",
      color:colorTheme('palette', 'positive').value,
      // bg: "#eafff1",
      bg:colorTheme('palette', 'positiveBg').value,
      // bd: "rgba(22,163,74,.35)",
      bd:colorTheme('palette', 'positive').value,
      icon: <SentimentSatisfiedAltRounded sx={{ fontSize: 16 }} />,
    },
    neutral: {
      label: "neutral",
      // color: "#6b7280",
      color:colorTheme('palette', 'neutral').value,
      // bg: "#f3f4f6",
      bg:colorTheme('palette', 'neutralBg').value,
      // bd: "rgba(107,114,128,.35)",
      bd:colorTheme('palette', 'neutral').value,
      icon: <SentimentNeutralRounded sx={{ fontSize: 16 }} />,
    },
    negative: {
      label: "negative",
      // color: "#dc2626",
      color:colorTheme('palette', 'negative').value,
      // bg: "#fee2e2",
      bg:colorTheme('palette', 'negativeBg').value,
      // bd: "rgba(220,38,38,.35)",
      bd:colorTheme('palette', 'negative').value,
      icon: <SentimentDissatisfiedRounded sx={{ fontSize: 16 }} />,
    },
  }

  const c = map[value] ?? map.neutral
  return (
    <Chip
      size="small"
      icon={c.icon}
      label={c.label}
      sx={{
        height: 24,
        bgcolor: c.bg,
        color: c.color,
        border: `1px solid ${c.bd}`,
        "& .MuiChip-icon": { color: c.color, ml: 0.5 },
        fontWeight: 700,
        fontSize:'0.8rem'
      }}
    />
  )
}


export default function FeedbackItem({ sentiment, text, category, timeAgo }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 5,
        p: { xs: 1.25, sm: "1rem" },
        backgroundColor: "#FAFAFB",
      }}
    >
      {/* Top row: sentiment and timestamp */}
      {/* <Box
        sx={{
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: 1,
          mb: 1,
          flexWrap: "wrap",
        }}
      >
        <SentimentChip value={sentiment} />

        <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
          <AccessTimeRounded sx={{ fontSize: 16, color: ui.subtext }} />
          <Typography variant="caption" sx={{ color: ui.subtext, fontWeight: 600 }}>
            {timeAgo}
          </Typography>
        </Box>
      </Box> */}

      {/* Quoted text */}
      <Typography
        variant="body2"
        sx={{
          color: ui.text,
          fontStyle: "italic",
          "&::before": { content: '"\\""' },
          "&::after": { content: '"\\""' },
        }}
      >
        {text}
      </Typography>

      {/* Category tag */}
      {/* <Chip
        size="small"
        label={category}
        sx={{
          mt: 1.25,
          height: 24,
          bgcolor: "#fff",
          color: ui.subtext,
          border: `1px solid ${ui.tagBorder}`,
          "& .MuiChip-label": { px: 1 },
          fontWeight: 700,
          width: "fit-content",
        }}
      /> */}
    </Paper>
  )
}
